import React, {useMemo} from "react";
import Card from "./Card";
import {StepProvider} from "../Fundamentals/Stepper/StepContext";
import {StepBody, StepFooter, StepHeader, StepHeaderType} from "../Fundamentals/Stepper/Step";
import Spinner from "../Fundamentals/Spinner/Spinner";

export const StepperCard = ({ title, isLoading, isStepLoading, stepHeaderType, children }) => {
    const childrenArray = useMemo(() => React.Children.toArray(children), [children]);
    return <Card isLoading={isLoading}>
        <StepProvider steps={childrenArray}>
            <Card.CHeader>
                <Card.Header.Title>{title}</Card.Header.Title>
            </Card.CHeader>
            <CardStepContainer stepHeaderType={stepHeaderType} isStepLoading={isStepLoading}/>
        </StepProvider>
    </Card>
};

const CardStepContainer = ({stepHeaderType, isStepLoading }) => {
    return <>
        <Card.Content>
            {stepHeaderType !== StepHeaderType.NONE && <StepHeader type={stepHeaderType} />}
            {isStepLoading ? <Spinner />: <StepBody />}
        </Card.Content>
        <Card.Footer>
            {!isStepLoading && <StepFooter/>}
        </Card.Footer>
    </>
}
